module.exports = __webpack_public_path__ + "static/Roadmap-8ae886d522d5b4c9cbfff022b07b35f6.svg";